import React from "react";

// Truncate to 100 words
const truncateWords = (text, limit = 100) => {
  if (!text) return "";
  const words = text.split(" ");
  return words.length > limit ? words.slice(0, limit).join(" ") + "..." : text;
};

const VideoCard = ({ rank, title, thumbnail, description }) => {
  return (
    <div className="flex flex-col bg-[#151d1a] text-white p-2 rounded-lg shadow-md w-full gap-4 mb-2">
      <div className="flex items-start gap-4 w-full">
        {/* Thumbnail with Rank */}
        <div className="relative w-36 h-20 flex-shrink-0">
          <img
            src={thumbnail}
            alt="thumbnail"
            className="w-full h-full object-cover rounded-md"
          />
          <div className="absolute top-0 left-0 bg-black bg-opacity-70 text-white text-xs px-2 py-0.5 rounded-br-md font-semibold">
            #{rank}
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-hidden">
          <div className="text-lg font-semibold truncate">{title}</div>
          {description && (
            <div className="text-sm text-gray-400 mt-1 line-clamp-2">
              {truncateWords(description, 100)}
            </div>
          )}
        </div>
      </div>
      {/* <div className="flex items-center justify-between ml-4 gap-2">
        <button className="w-[50%] bg-gray-800 py-2 rounded-lg hover:bg-gray-700 transition-colors">
          Paste Content
        </button>
        <button className="w-[50%] bg-gray-800 py-2 rounded-lg hover:bg-gray-700 transition-colors">
          Content Cart
        </button>
      </div> */}
    </div>
  );
};

export default VideoCard;
